module.exports = __webpack_public_path__ + "img/JavaScript.891a71b9.svg";